export default __webpack_public_path__ + "static/media/interview.645b40b2.svg";